import { Injectable } from '@angular/core';
import { Observable, of, zip } from 'rxjs';
import { flatMap, map } from 'rxjs/operators';
import { InspectionPlugin } from '../../../shared/models';
import { InspectionFactoryService } from '../../../shared/services/inspectionFactory.service';
import { ApiService, DataService, InspectionPluginService } from '../../../shared/services';

@Injectable()
export class InstallationCustomerAttendeesPluginService extends InspectionPluginService {
  constructor(
    protected apiService: ApiService,
    protected dataService: DataService,
    protected factory: InspectionFactoryService
  ) {
    super(apiService, dataService, null);
  }

  public getCustomerContacts(inspectionId: string): Observable<any[]> {
    return zip(
      this.dataService.getInspectionLevelPlugin(inspectionId, 'installationcustomercontact'),
      this.dataService.getParrentInspectionLevelPlugin(inspectionId, 'installationcustomercontact')
    ).map(([p, p1]) => {
      return [...(p?.config?.CustomerContacts ?? []), ...(p1?.config?.CustomerContacts ?? [])];
    });
  }

  public updateAttendees(inspectionId: string, pointId: string, pluginId: string, attendees: any[]): Observable<any> {
    attendees.forEach((r) => {
      if (!r.Id) {
        r.Id = this.factory.guid();
      }
    });
    return this.update(inspectionId, pointId, pluginId, attendees).pipe(
      map((res: InspectionPlugin) => {
        this.dataService.setChangedPoint(pointId);
        return this.dataService.updatePlugin(inspectionId, res);
      })
    );
  }

  private update(inspectionId: string, pointId: string, pluginId: string, anilox: any[]): Observable<any> {
    return this.factory.updatePluginConfig(inspectionId, pointId, pluginId, anilox, 'Attendees').pipe(
      flatMap((plugin: InspectionPlugin) => {
        if (this.isInspectionInOffline(inspectionId)) {
          return of(plugin);
        }
        return this.apiService.post(plugin.postServerUrl, plugin.config);
      })
    );
  }
}
